import { bl_sfa_sales_lead_contact_link_RowClass } from "../../../dbschema/bl_sfa_sales_lead_contact_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaSalesLeadContactLinkContainerModel extends BaseContainerModel {
    bl_sfa_sales_lead_contact_link: bl_sfa_sales_lead_contact_link_RowClass = new bl_sfa_sales_lead_contact_link_RowClass()
}